export default __webpack_public_path__ + "static/media/drop-orange.f10f2f85.svg";